import { useEffect, useState } from 'react';
import DownloadSimpleLight from '@/assets/downloadSimpleLight.svg';
import XLight from '@/assets/xLight.svg';
import FilePdfLight from '@/assets/filePdfLight.svg';
import FilePptLight from '@/assets/file-ppt-light.svg';
import ProgressCircular from '@/components/general/ProgressCircular';
import Modal from '@/components/general/Modal';

type AnalyticsBuilderExportModalProps = {
  open: boolean;
  onClose: () => void;
};

const AnalyticsBuilderExportModal = ({ open, onClose }: AnalyticsBuilderExportModalProps) => {
  const [downloadingFormat, setDownloadingFormat] = useState<string | null>(null);
  const options = [
    { label: 'Word', icon: FilePdfLight },
    { label: 'PowerPoint', icon: FilePptLight },
    { label: 'PDF', icon: FilePdfLight },
  ];

  useEffect(() => {
    if (!open) {
      setDownloadingFormat(null);
    }
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      disableCloseOnBackdropClick
      contanerClassName="w-auto h-auto bg-white !rounded-none lg:!rounded-md disable-scroll"
    >
      <div className="flex items-center justify-between border-b border-zinc-100 px-6 py-4">
        <div>
          <p className="text-h5">Export</p>
        </div>
        <button onClick={onClose} className="btn icon">
          <XLight className="h-7 w-7" />
        </button>
      </div>
      <div className="flex min-w-[330px] flex-col gap-4 px-6 py-4">
        <div className="flex flex-col gap-2">
          {options.map(({ label, icon: Icon }) => (
            <div key={label} className="flex flex-row items-center justify-between gap-2">
              <div className="flex flex-row gap-5">
                <Icon className="h-7 w-7" />
                <div className="text-sm text-black/60">{label}</div>
              </div>
              <button
                className="btn icon"
                disabled={Boolean(downloadingFormat)}
                onClick={() => setDownloadingFormat(label)}
              >
                {downloadingFormat === label ? (
                  <ProgressCircular indeterminate size={28} width={3} colorClassName="stroke-black/80" />
                ) : (
                  <DownloadSimpleLight className="h-7 w-7" />
                )}
              </button>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default AnalyticsBuilderExportModal;
